﻿﻿export interface IDonorPreselectNote {
    id: number;
    recipientCenterId: number;
    recipientId: number;
    donorId: number;
    note: string;
}
